module.exports = __webpack_public_path__ + "media/bootstrap-icons/voicemail-f1b4e24a.svg";